// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".created-column[data-v-004b5053]{max-width:100%;grid-area:created}.created-column__toggle-packages-btn[data-v-004b5053]{width:-moz-fit-content!important;width:fit-content!important;padding:0!important}.created-column__toggle-packages-btn[data-v-004b5053]:before{display:none!important}", ""]);
// Exports
module.exports = exports;
